import {Component, OnInit, Input} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {VoucherService} from '@app/core/services';
import {Store} from '@ngrx/store';
import {VoucherAddNew} from 'app/state/voucher/app.actions-voucher';
import * as moment from 'moment';

@Component({
    selector: 'app-voucher',
    templateUrl: './voucher.component.html',
    styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements OnInit {
    @Input() idEtab: number = null;
    @Input() idRooms: Array<{id: number, price: number}> = [];
    @Input() start: moment.Moment;
    @Input() end: moment.Moment;
    submitted: boolean = false;

    codeFormControl = new FormControl('', [
        Validators.required,
    ]);
    constructor(
        private voucherService: VoucherService,
        private store: Store<any>,
    ) {}

    ngOnInit() {
    }

    save(value: string) {
        this.submitted = true;
        this.voucherService.checkVoucher(value, this.idRooms, this.start.locale('en').format('YYYY-MM-DD'), this.end.locale('en').format('YYYY-MM-DD'), this.idEtab).subscribe((result) => {
            if (!!result.status) {
                this.store.dispatch(new VoucherAddNew({voucher: value, result: result.response}));
                //} else {
            }
        }, () => {
            this.submitted = false;
        }, () => {
            this.submitted = false;
        })
    }
}
